import type { ReduxState } from '@/utils/typeHelpers'

export const selectPlanOptions = (state: ReduxState) =>
  state.planChange.planOptions

export const selectPlanOptionsFetchedAt = (state: ReduxState) =>
  state.planChange.fetchedAt

export const selectLastAppliedChange = (state: ReduxState) =>
  state.planChange.lastAppliedChange

export const selectPlanCatalog = (state: ReduxState) =>
  state.planChange.planCatalog

export const selectCatalogRequestId = (state: ReduxState) =>
  state.planChange.catalogRequest.id

export const selectHasCatalogRequestFailed = (state: ReduxState) =>
  state.planChange.catalogRequest.status === 'failed'

export const selectPlanCustomerType = (state: ReduxState) =>
  state.planChange.planOptions?.customerType ?? null

/** The held plan's tier when it is on a legacy product, which is the one plan the page names as such. */
export const selectLegacyHeldTier = (state: ReduxState) => {
  const currentPlan = state.planChange.planOptions?.currentPlan
  return currentPlan?.onCatalogProduct === false ? currentPlan.tier : null
}
